import { useState } from 'react';
import { CoachAvailabilityInterval } from 'coaching/CoachingConstants';

export default function useTimeIntervals(initialIntervals?: CoachAvailabilityInterval[]) {
  const [intervals, setIntervals] = useState(initialIntervals ?? []);
  const addInterval = (interval: CoachAvailabilityInterval, index: number) => {
    intervals.splice(index, 0, interval);
    setIntervals([...intervals]);
  };

  const removeInterval = (index: number, callback?: () => void) => {
    intervals.splice(index, 1);
    setIntervals([...intervals]);
    callback?.();
  };

  const updateIntervalStartTime = (newStartTime: string, endTime: string, index: number) => {
    removeInterval(index, () =>
      addInterval(
        {
          startTime: newStartTime,
          endTime,
        },
        index
      )
    );
  };

  const updateIntervalEndTime = (startTime: string, newEndTime: string, index: number) => {
    removeInterval(index, () =>
      addInterval(
        {
          startTime,
          endTime: newEndTime,
        },
        index
      )
    );
  };

  const defaultInterval = {
    startTime: '07:00',
    endTime: '23:00',
  };

  return {
    intervals,
    addInterval,
    removeInterval,
    updateIntervalEndTime,
    updateIntervalStartTime,
    defaultInterval,
  };
}
